class ctxTableTreeviewTwistieDirective {
    constructor($compile, ivhTreeviewOptions) {
        this.$compile = $compile;
        this.globalOpts = ivhTreeviewOptions();
        this.restrict = 'A';
        this.require = '^ctxTableTreeview';
        this.template = [
            '<span class="ivh-treeview-twistie">',
            '<span class="ivh-treeview-twistie-collapsed">',
            this.globalOpts.twistieCollapsedTpl,
            '</span>',
            '<span class="ivh-treeview-twistie-expanded">',
            this.globalOpts.twistieExpandedTpl,
            '</span>',
            '<span class="ivh-treeview-twistie-leaf">',
            this.globalOpts.twistieLeafTpl,
            '</span>',
            '</span>'
        ].join('\n');
    }

    link(scope, element, attrs, trvw) {

        if (!trvw.hasLocalTwistieTpls) {
            return;
        }

        let opts = trvw.opts(), $twistieContainers = element.children().eq(0).children();

        angular.forEach([
            'twistieCollapsedTpl',
            'twistieExpandedTpl',
            'twistieLeafTpl'
        ], (tplKey, ix) => {
            let tpl = opts[tplKey], tplGlobal = this.globalOpts[tplKey];

            // Do nothing if we don't have a new template
            if (!tpl || tpl === tplGlobal) {
                return;
            }

            if (tpl.substr(0, 1) !== '<' || tpl.substr(-1, 1) !== '>') {
                tpl = '<span>' + tpl + '</span>';
            }

            var $el = this.$compile(tpl)(scope), $container = $twistieContainers.eq(ix);

            $container.html('').append($el);
        });

    }

    static directiveFactory($compile, ivhTreeviewOptions) {
        return new ctxTableTreeviewTwistieDirective($compile, ivhTreeviewOptions);
    }
}

ctxTableTreeviewTwistieDirective.directiveFactory.$inject = ['$compile', 'ivhTreeviewOptions'];

module.exports = ctxTableTreeviewTwistieDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewTwistie.directive.js